import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Select from 'apps/web_forms/components/commons/Select';
import { EMPTY_DATETIME_VALUE } from 'apps/web_forms/utils/constants';

const TimeSelectsContainer = styled.div`
  position: relative;
  z-index: 2;
  display: flex;

  .select-container {
    margin-right: 0.9em;
  }
`;

const optionsHours = createHoursOptionsArray();
const optionsMinutes = createMinutesOptionsArray(60);

const Time = ({
  identifier,
  initialValue,
  onChange,
  customHour,
  onCustomHourChange,
  customMinutes,
  onCustomMinutesChange,
  isValid,
  hasResourceUpdateHighlight,
  removeResourceUpdateHighlight,
  readOnly,
}) => {
  const [seconds, setSeconds] = useState('00');
  const [minutes, setMinutes] = useState('');
  const [hour, setHour] = useState('');

  useEffect(() => {
    if (initialValue) {
      const initialValues = initialValue.split(':');
      setHour(initialValues[0]);
      setMinutes(initialValues[1]);
      // setSeconds(initialValues[2]);
    }
  }, []);

  useEffect(() => {
    if (hour && minutes) {
      onChange(`${hour}:${minutes}:${seconds}`);
    }
     else if (hour === EMPTY_DATETIME_VALUE || minutes === EMPTY_DATETIME_VALUE){
      onChange(EMPTY_DATETIME_VALUE);
    }
  }, [hour, minutes]);

  const onHourChange = useCallback(
    (newHour) => {
      if (minutes &&( !newHour || newHour === EMPTY_DATETIME_VALUE)) {
        setMinutes('');
      } else if ((!minutes || minutes  === EMPTY_DATETIME_VALUE) && newHour) {
        setMinutes('00');
      }
      setHour(newHour);
    },
    [minutes]
  );

  const onMinutesChange = useCallback(
    (newMinute) => {
      if (hour && (!newMinute || newMinute === EMPTY_DATETIME_VALUE) ) {
        setHour('');
      } else if ((!hour || hour === EMPTY_DATETIME_VALUE) && newMinute) {
        setHour('00');
      }
      setMinutes(newMinute);
    },
    [hour]
  );

  return (
    <TimeSelectsContainer>
      <div className='select-container'>
        <Select
          id={`${identifier}_hour`}
          name='hours'
          onSelect={onCustomHourChange || onHourChange}
          options={optionsHours}
          parentValue={hour || customHour || ''}
          isValid={isValid}
          hasResourceUpdateHighlight={hasResourceUpdateHighlight}
          removeResourceUpdateHighlight={removeResourceUpdateHighlight}
          disabled={readOnly}
          reactSelect={false}
        />
      </div>
      <div className='select-container'>
        <Select
          id={`${identifier}_minutes`}
          name='minutes'
          onSelect={onCustomMinutesChange || onMinutesChange}
          options={optionsMinutes}
          parentValue={minutes || customMinutes || ''}
          isValid={isValid}
          hasResourceUpdateHighlight={hasResourceUpdateHighlight}
          removeResourceUpdateHighlight={removeResourceUpdateHighlight}
          disabled={readOnly}
          reactSelect={false}
        />
      </div>
    </TimeSelectsContainer>
  );
};

function createHoursOptionsArray() {
  const opts = [{ label: '12 AM', value: '00' }];

  for (let i = 1; i < 24; i++) {
    if (i < 12) {
      opts.push({ value: `${i < 10 ? `0${i}` : i}`, label: `${i} AM` });
    } else if (i === 12) {
      opts.push({ label: `12 PM`, value: i });
    } else {
      opts.push({ label: `${i - 12} PM`, value: i });
    }
  }
  return opts;
}

function createMinutesOptionsArray(number) {
  const opts = [];
  for (let i = 0; i < number; i++) {
    opts.push({
      label: `${i < 10 ? `0${i}` : i}`,
    });
  }
  return opts;
}

Time.propTypes = {
  identifier: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  customHour: PropTypes.string,
  onCustomHourChange: PropTypes.func,
  customMinutes: PropTypes.string,
  onCustomMinutesChange: PropTypes.func,
  isValid: PropTypes.bool,
  hasResourceUpdateHighlight: PropTypes.bool,
  removeResourceUpdateHighlight: PropTypes.func,
  readOnly: PropTypes.bool,
  initialValue: PropTypes.string,
};

Time.defaultProps = {
  onChange: null,
  customHour: null,
  onCustomHourChange: null,
  customMinutes: null,
  onCustomMinutesChange: null,
  isValid: true,
  hasResourceUpdateHighlight: false,
  removeResourceUpdateHighlight: () => {},
  readOnly: false,
  initialValue: null,
};

export default Time;
